import "../styles/pages/home.scss";
import { Typography, Container, Divider, Rating } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import Image from "../../Utils/getImage";
import dummy from "../assets/dummyuser.jpg";

const Aboutus = ({ data }) => {

  if (!data || data.length === 0) {
    return null;
  }
  // console.log(data)
  
  return (
    <section className="about-section">
      <Container maxWidth="lg">
        <div className="about-title">
          <Typography variant="h3" align="center">
            Our Customers Say It Best
          </Typography>
          <Typography variant="h6" align="center">
            See Why They Love Us
          </Typography>
        </div>

        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop={data.length > 2}
          autoplay={
            data.length > 1
      ? {
          delay: 3000,
          disableOnInteraction: true,
        }
      : false
          }
          slidesPerView={"auto"}
          navigation={data.length > 1}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          modules={[EffectCoverflow, Navigation, Autoplay]}
          className="testimonial-swiper"
        >
          {data.map((item, index) => (
            <SwiperSlide key={index} className="testimonial-slide">
              <div className="testimonial-card">
                <div className="testimonial-image">
                  {item.customer_id?.profile_pic ? (
                    <Image
                      className="testimonial-img"
                      src={item?.customer_id?.profile_pic}
                      alt={item.name}
                    />
                  ) : (
                    <img className="testimonial-img" src={dummy} alt="" />
                  )}
                </div>
                <div className="testimonial-content">
                  <p className="testimonial-text">“{item?.comment}”</p>
                  <Divider className="small-screen" />
                  <div className="testimonial-stars">
                    <Rating name="half-rating-read" defaultValue={Number(item.rating)} precision={0.5} readOnly />
                  </div>
                  <Typography variant="h6" className="testimonial-name">
                    {item?.customer_id?.name}
                  </Typography>
                </div>
              </div>
              
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Aboutus;
